/**
 * Google Map plugin for jQuery
 * author: Filip Hladík (2011 - 2017, FG Forrest, a.s.)
 * 	*******************************************************************************************************************
 * 3rd parties
 * 	- MarkerClusterer - https://google-maps-utility-library-v3.googlecode.com/svn/trunk/markerclusterer/docs/reference.html
 * 	- InfoBox (heavily changed to match the FG requirements) - http://google-maps-utility-library-v3.googlecode.com/svn/trunk/infobox/docs/reference.html
 *
 * 	*******************************************************************************************************************
 * 	INITIAL USAGE: $('div.map').googlemap(SETTINGS);
 * 	*******************************************************************************************************************
 *
 * 	SETTINGS - { key: value, key2: value2, ...}
 *
 * 	width [integer] [DEFAULT null] - width of the map, in pixels.
 * 		- if not given, map inherits width from element, that the map plugin has been applied to
 *
 * 	height [integer] [DEFAULT null] - height of the map, in pixels
 * 		- if not given, same behavior as width
 *
 * 	mapOptions [object]
 * 	startingPosition : {	// [object] - set center of the map
 * 		{
 *			lat: x			// latitude - float
 *			lng: y			// longitude - float
 *			zoom: z			// zoom - integer
 * 		},
 * 		mapTypeControl:		true,			// [boolean] [DEFAULT true] - enables controls to change map type (ROADMAP, TERRAIN, etc...)
 * 		mapTypeId:  		'ROADMAP',		// [enum - HYBRID | TERRAIN | ROADMAP | SATELLITE] [DEFAULT ROADMAP] - type of initially loaded map
 * 		scaleControl:		true, 			// [boolean] [DEFAULT true] - enables layer with map scale information
 * 		panControl:			true,			// [boolean] [DEFAULT true] - enables controls to move map
 * 		streetViewControl:	true,			// [boolean] [DEFAULT true] - enables streetView
 * 		zoomControl:		true, 			// [boolean] [DEFAULT true] - enables controls to zoom the map
 * 		zoomControlPosition: {
 * 		 position: 'LEFT_CENTER' // [LEFT_TOP | LEFT_CENTER | LEFT_BOTTOM | RIGHT_TOP | RIGHT_CENTER | RIGHT_BOTTOM] [DEFAULT = 'RIGHT_BOTTOM']
 * 		}
 * 		maxZoom:			x,				// [integer]
 * 		minZoom:			y,				// [integer]
 * 		scrollwheel:		true,			// [boolean] [DEFAULT true] - enables map zooming with mouse scroll
 * 		draggable:			true,			// [boolean] [DEFAULT true] - enables map panning
 *  	zoomControlPosition: {
 * 		 position: 'LEFT_CENTER' // [LEFT_TOP | LEFT_CENTER | LEFT_BOTTOM | RIGHT_TOP | RIGHT_CENTER | RIGHT_BOTTOM] [DEFAULT = 'RIGHT_TOP']
 * 		}
 * 		styles:				[]				// [array of objects] - style your map your way, based on https://developers.google.com/maps/tutorials/customizing/styling-the-base-map
 * 	}
 *
 * 	markerTypes [array of objects] - define your own icon styles
 * 	[{
 *		icon:	{
 *			url: '/path/to/image',
 *			size: new google.maps.Size(x, y),			// size of marker in px [x - width, y - height]
 *			origin: new google.maps.Point(x, y),		// position of marker image in sprite (if given) [x - position from the left, y - position from the top]
 *			anchor: new google.maps.Point(x, y)     	// tip of the marker [x - from the left, y - from the top]
 *		},
 *		shape:	{																// https://developers.google.com/maps/documentation/javascript/reference#MarkerShape
 *			coords:		[x1,y1,x2,y2] || [x, y, r] || [x1, y1, ... xn, yn],		// cordinates making the part of the marker clickable
 *			type:		'value'													// type of shape [ENUM - rect | circle | poly]
 *		}
 * 	}]
 *
 * 	labelFormat [object] - define label design
 * 	{
 *		color
 *		fontWeight
 *		fontSize
 *		fontFamily
 * 	}
 *
 * 	showAllMarkersOnEmptyFilter [boolean] [DEFAULT true] - used when filtering, if true, all markers are displayed when filter is empty object
 *
 * 	clustering [object] - usage of MarkerClusterer
 * 	{
 *		enabled: false,			// self-explanatory
 *		mode: value,			// [enum - all | type] [DEFAULT all] - cluster all icons, icons by type, icons by collectionId
 *		groups: {
 *          group1: {
 *          	categories: [],	// array of markers type, which should be included in this cluster group
 *          	iconsStyles: []	// custom iconsStyles for this group
 *          }
 *		},
 *   	iconsStyles: [			// [array of objects] - custom cluster icons, there are 5 sizes of cluster icons, define them all, if you use this feature
 *			{
 *				anchor: [y, x],								// y - position of the number from the top, x - position of the number from the left
 *																- if any of these numbers is -1, the number is centered at that direction
 *				textColor: '#fff',							// color of the number on the groupped marker
 *				url: '/path/to/image',						// self-explanatory
 *				height: 50,									// height of the groupped marker
 *				width: 50,									// width of the groupped marker
 *				textSize: 12,								// font size of the number
 *				margin: '-25px 0 0 0'						// set the pointing tip of the marker, originaly is center of the marker.
 *																- this settings sets the pointing tip to the bottom of the marker (- half of height)
 *			}
 *   	],
 *   	maxZoom: x,											// level of zoom, where groupping of markers will not be applied
 *   	batchSize: x,                                       // number of markers that are processed in one batch
 *   	batchSizeIE: x,										// the same - IE
 *   	gridSize: x											// sets size of the box to cluster, default: 60px
 * 	}
 *
 * 	oneBubbleAtOnce: true									// [boolean] - if true, you can have only one marker infowindow displayed
 *
 * 	bubbleContentFormatter: function(mData) {				// [function] - set your custom function to format content of the infowindow
 *															//	- the only parameter given is markersData provided in loadMarkers method
 * 	}														//	- function must return STRING
 *
 *
 * 	*******************************************************************************************************************
 */

;(function($, window, document, undefined ) {
  "use strict";

  if (typeof google !== 'undefined') {

    function ClusterIcon(e, t) {
      e.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);
      this.cluster_ = e;
      this.className_ = e.getMarkerClusterer().getClusterClass();
      this.styles_ = t;
      this.center_ = null;
      this.div_ = null;
      this.sums_ = null;
      this.visible_ = false;
      this.setMap(e.getMap())
    }

    function Cluster(e) {
      this.markerClusterer_ = e;
      this.map_ = e.getMap();
      this.gridSize_ = e.getGridSize();
      this.minClusterSize_ = e.getMinimumClusterSize();
      this.averageCenter_ = e.getAverageCenter();
      this.printable_ = e.getPrintable();
      this.markers_ = [];
      this.center_ = null;
      this.bounds_ = null;
      this.clusterIcon_ = new ClusterIcon(this, e.getStyles())
    }

    function MarkerClusterer(e, t, n) {
      this.extend(MarkerClusterer, google.maps.OverlayView);
      t = t || [];
      n = n || {};
      this.markers_ = [];
      this.clusters_ = [];
      this.listeners_ = [];
      this.activeMap_ = null;
      this.ready_ = false;
      this.gridSize_ = n.gridSize || 60;
      this.minClusterSize_ = n.minimumClusterSize || 2;
      this.maxZoom_ = n.maxZoom || null;
      this.styles_ = n.styles || [];
      this.title_ = n.title || "";
      this.zoomOnClick_ = true;
      if (n.zoomOnClick !== undefined) {
        this.zoomOnClick_ = n.zoomOnClick
      }
      this.averageCenter_ = false;
      if (n.averageCenter !== undefined) {
        this.averageCenter_ = n.averageCenter
      }
      this.ignoreHidden_ = false;
      if (n.ignoreHidden !== undefined) {
        this.ignoreHidden_ = n.ignoreHidden
      }
      this.printable_ = false;
      if (n.printable !== undefined) {
        this.printable_ = n.printable
      }
      this.imagePath_ = n.imagePath || MarkerClusterer.IMAGE_PATH;
      this.imageExtension_ = n.imageExtension || MarkerClusterer.IMAGE_EXTENSION;
      this.imageSizes_ = n.imageSizes || MarkerClusterer.IMAGE_SIZES;
      this.calculator_ = n.calculator || MarkerClusterer.CALCULATOR;
      this.batchSize_ = n.batchSize || MarkerClusterer.BATCH_SIZE;
      this.batchSizeIE_ = n.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;
      this.clusterClass_ = n.clusterClass || "cluster";
      if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
        this.batchSize_ = this.batchSizeIE_
      }
      this.setupStyles_();
      this.addMarkers(t, true);
      this.setMap(e)
    }

    ClusterIcon.prototype.onAdd = function () {
      var e = this;
      var t;
      var n;
      this.div_ = document.createElement("div");
      this.div_.className = this.className_;
      if (this.visible_) {
        this.show()
      }
      this.getPanes().overlayMouseTarget.appendChild(this.div_);
      google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
        n = t
      });
      google.maps.event.addDomListener(this.div_, "mousedown", function () {
        t = true;
        n = false
      });
      google.maps.event.addDomListener(this.div_, "click", function (r) {
        t = false;
        if (!n) {
          var i;
          var s;
          var o = e.cluster_.getMarkerClusterer();
          google.maps.event.trigger(o, "click", e.cluster_);
          google.maps.event.trigger(o, "clusterclick", e.cluster_);
          if (o.getZoomOnClick()) {
            s = o.getMaxZoom();
            i = e.cluster_.getBounds();
            o.getMap().fitBounds(i);
            setTimeout(function () {
              o.getMap().fitBounds(i);
              if (s !== null && o.getMap().getZoom() > s) {
                o.getMap().setZoom(s + 1)
              }
            }, 100)
          }
          r.cancelBubble = true;
          if (r.stopPropagation) {
            r.stopPropagation()
          }
        }
      });
      google.maps.event.addDomListener(this.div_, "mouseover", function () {
        var t = e.cluster_.getMarkerClusterer();
        google.maps.event.trigger(t, "mouseover", e.cluster_)
      });
      google.maps.event.addDomListener(this.div_, "mouseout", function () {
        var t = e.cluster_.getMarkerClusterer();
        google.maps.event.trigger(t, "mouseout", e.cluster_)
      })
    };
    ClusterIcon.prototype.onRemove = function () {
      if (this.div_ && this.div_.parentNode) {
        this.hide();
        google.maps.event.clearInstanceListeners(this.div_);
        this.div_.parentNode.removeChild(this.div_);
        this.div_ = null
      }
    };
    ClusterIcon.prototype.draw = function () {
      if (this.visible_) {
        var e = this.getPosFromLatLng_(this.center_);
        this.div_.style.top = e.y + "px";
        this.div_.style.left = e.x + "px"
      }
    };
    ClusterIcon.prototype.hide = function () {
      if (this.div_) {
        this.div_.style.display = "none"
      }
      this.visible_ = false
    };
    ClusterIcon.prototype.show = function () {
      if (this.div_) {
        var e = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(e);
        if (this.cluster_.printable_) {
          this.div_.innerHTML = "<img src='" + this.url_ + "'><div style='position: absolute; top: 0px; left: 0px; width: " + this.width_ + "px;'>" + this.sums_.text + "</div>"
        } else {
          this.div_.innerHTML = this.sums_.text
        }
        if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
          this.div_.title = this.cluster_.getMarkerClusterer().getTitle()
        } else {
          this.div_.title = this.sums_.title
        }
        this.div_.style.display = ""
      }
      this.visible_ = true
    };
    ClusterIcon.prototype.useStyle = function (e) {
      this.sums_ = e;
      var t = Math.max(0, e.index - 1);
      t = Math.min(this.styles_.length - 1, t);
      var n = this.styles_[t];
      this.url_ = n.url;
      this.height_ = n.height;
      this.width_ = n.width;
      this.anchor_ = n.anchor;
      this.anchorIcon_ = n.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];
      this.textColor_ = n.textColor || "black";
      this.textSize_ = n.textSize || 11;
      this.textDecoration_ = n.textDecoration || "none";
      this.fontWeight_ = n.fontWeight || "bold";
      this.fontStyle_ = n.fontStyle || "normal";
      this.fontFamily_ = n.fontFamily || "Arial,sans-serif";
      this.backgroundPosition_ = n.backgroundPosition || "0 0";
      this.margin_ = n.margin || "0"
    };
    ClusterIcon.prototype.setCenter = function (e) {
      this.center_ = e
    };
    ClusterIcon.prototype.createCss = function (e) {
      var t = [];
      if (!this.cluster_.printable_) {
        t.push("background-image:url(" + this.url_ + ");");
        t.push("background-position:" + this.backgroundPosition_ + ";")
      }
      if (typeof this.anchor_ === "object") {
        if (typeof this.anchor_[0] === "number" && this.anchor_[0] >= 0 && this.anchor_[0] < this.height_) {
          t.push("height:" + (this.height_ - this.anchor_[0]) + "px; padding-top:" + this.anchor_[0] + "px;")
        } else {
          t.push("height:" + this.height_ + "px; line-height:" + this.height_ + "px;")
        }
        if (typeof this.anchor_[1] === "number" && this.anchor_[1] >= 0 && this.anchor_[1] < this.width_) {
          t.push("width:" + (this.width_ - this.anchor_[1]) + "px; padding-left:" + this.anchor_[1] + "px;")
        } else {
          t.push("width:" + this.width_ + "px; text-align:center;")
        }
      } else {
        t.push("height:" + this.height_ + "px; line-height:" + this.height_ + "px; width:" + this.width_ + "px; text-align:center;")
      }
      t.push("cursor:pointer; color:" + this.textColor_ + "; position:absolute; font-size:" + this.textSize_ + "px; font-family:" + this.fontFamily_ + "; font-weight:" + this.fontWeight_ + "; font-style:" + this.fontStyle_ + "; text-decoration:" + this.textDecoration_ + "; margin:" + this.margin_ + ";");
      return t.join("")
    };
    ClusterIcon.prototype.getPosFromLatLng_ = function (e) {
      var t = this.getProjection().fromLatLngToDivPixel(e);
      t.x -= this.anchorIcon_[1];
      t.y -= this.anchorIcon_[0];
      return t
    };
    Cluster.prototype.getSize = function () {
      return this.markers_.length
    };
    Cluster.prototype.getMarkers = function () {
      return this.markers_
    };
    Cluster.prototype.getCenter = function () {
      return this.center_
    };
    Cluster.prototype.getMap = function () {
      return this.map_
    };
    Cluster.prototype.getMarkerClusterer = function () {
      return this.markerClusterer_
    };
    Cluster.prototype.getBounds = function () {
      var e;
      var t = new google.maps.LatLngBounds(this.center_, this.center_);
      var n = this.getMarkers();
      for (e = 0; e < n.length; e++) {
        t.extend(n[e].getPosition())
      }
      return t
    };
    Cluster.prototype.remove = function () {
      this.clusterIcon_.setMap(null);
      this.markers_ = [];
      delete this.markers_
    };
    Cluster.prototype.addMarker = function (e) {
      var t;
      var n;
      var r;
      if (this.isMarkerAlreadyAdded_(e)) {
        return false
      }
      if (!this.center_) {
        this.center_ = e.getPosition();
        this.calculateBounds_()
      } else {
        if (this.averageCenter_) {
          var i = this.markers_.length + 1;
          var s = (this.center_.lat() * (i - 1) + e.getPosition().lat()) / i;
          var o = (this.center_.lng() * (i - 1) + e.getPosition().lng()) / i;
          this.center_ = new google.maps.LatLng(s, o);
          this.calculateBounds_()
        }
      }
      e.isAdded = true;
      this.markers_.push(e);
      n = this.markers_.length;
      r = this.markerClusterer_.getMaxZoom();
      if (r !== null && this.map_.getZoom() > r) {
        if (e.getMap() !== this.map_) {
          e.setMap(this.map_)
        }
      } else if (n < this.minClusterSize_) {
        if (e.getMap() !== this.map_) {
          e.setMap(this.map_)
        }
      } else if (n === this.minClusterSize_) {
        for (t = 0; t < n; t++) {
          this.markers_[t].setMap(null)
        }
      } else {
        e.setMap(null)
      }
      this.updateIcon_();
      return true
    };
    Cluster.prototype.isMarkerInClusterBounds = function (e) {
      return this.bounds_.contains(e.getPosition())
    };
    Cluster.prototype.calculateBounds_ = function () {
      var e = new google.maps.LatLngBounds(this.center_, this.center_);
      this.bounds_ = this.markerClusterer_.getExtendedBounds(e)
    };
    Cluster.prototype.updateIcon_ = function () {
      var e = this.markers_.length;
      var t = this.markerClusterer_.getMaxZoom();
      if (t !== null && this.map_.getZoom() > t) {
        this.clusterIcon_.hide();
        return
      }
      if (e < this.minClusterSize_) {
        this.clusterIcon_.hide();
        return
      }
      var n = this.markerClusterer_.getStyles().length;
      var r = this.markerClusterer_.getCalculator()(this.markers_, n);
      this.clusterIcon_.setCenter(this.center_);
      this.clusterIcon_.useStyle(r);
      this.clusterIcon_.show()
    };
    Cluster.prototype.isMarkerAlreadyAdded_ = function (e) {
      var t;
      if (this.markers_.indexOf) {
        return this.markers_.indexOf(e) !== -1
      } else {
        for (t = 0; t < this.markers_.length; t++) {
          if (e === this.markers_[t]) {
            return true
          }
        }
      }
      return false
    };
    MarkerClusterer.prototype.onAdd = function () {
      var e = this;
      this.activeMap_ = this.getMap();
      this.ready_ = true;
      this.repaint();
      this.listeners_ = [google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
        e.resetViewport_(false);
        if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
          google.maps.event.trigger(this, "idle")
        }
      }), google.maps.event.addListener(this.getMap(), "idle", function () {
        e.redraw_()
      })]
    };
    MarkerClusterer.prototype.onRemove = function () {
      var e;
      for (e = 0; e < this.markers_.length; e++) {
        if (this.markers_[e].getMap() !== this.activeMap_) {
          this.markers_[e].setMap(this.activeMap_)
        }
      }
      for (e = 0; e < this.clusters_.length; e++) {
        this.clusters_[e].remove()
      }
      this.clusters_ = [];
      for (e = 0; e < this.listeners_.length; e++) {
        google.maps.event.removeListener(this.listeners_[e])
      }
      this.listeners_ = [];
      this.activeMap_ = null;
      this.ready_ = false
    };
    MarkerClusterer.prototype.draw = function () {
    };
    MarkerClusterer.prototype.setupStyles_ = function () {
      var e, t, n;
      if (this.styles_.length > 0) {
        return
      }
      for (e = 0; e < this.imageSizes_.length; e++) {
        t = this.imageSizes_[e][0];
        n = this.imageSizes_[e][1];
        this.styles_.push({url: this.imagePath_ + (e + 1) + "." + this.imageExtension_, height: n, width: t})
      }
    };
    MarkerClusterer.prototype.fitMapToMarkers = function () {
      var e;
      var t = this.getMarkers();
      var n = new google.maps.LatLngBounds;
      for (e = 0; e < t.length; e++) {
        n.extend(t[e].getPosition())
      }
      this.getMap().fitBounds(n)
    };
    MarkerClusterer.prototype.getGridSize = function () {
      return this.gridSize_
    };
    MarkerClusterer.prototype.setGridSize = function (e) {
      this.gridSize_ = e
    };
    MarkerClusterer.prototype.getMinimumClusterSize = function () {
      return this.minClusterSize_
    };
    MarkerClusterer.prototype.setMinimumClusterSize = function (e) {
      this.minClusterSize_ = e
    };
    MarkerClusterer.prototype.getMaxZoom = function () {
      return this.maxZoom_
    };
    MarkerClusterer.prototype.setMaxZoom = function (e) {
      this.maxZoom_ = e
    };
    MarkerClusterer.prototype.getStyles = function () {
      return this.styles_
    };
    MarkerClusterer.prototype.setStyles = function (e) {
      this.styles_ = e
    };
    MarkerClusterer.prototype.getTitle = function () {
      return this.title_
    };
    MarkerClusterer.prototype.setTitle = function (e) {
      this.title_ = e
    };
    MarkerClusterer.prototype.getZoomOnClick = function () {
      return this.zoomOnClick_
    };
    MarkerClusterer.prototype.setZoomOnClick = function (e) {
      this.zoomOnClick_ = e
    };
    MarkerClusterer.prototype.getAverageCenter = function () {
      return this.averageCenter_
    };
    MarkerClusterer.prototype.setAverageCenter = function (e) {
      this.averageCenter_ = e
    };
    MarkerClusterer.prototype.getIgnoreHidden = function () {
      return this.ignoreHidden_
    };
    MarkerClusterer.prototype.setIgnoreHidden = function (e) {
      this.ignoreHidden_ = e
    };
    MarkerClusterer.prototype.getImageExtension = function () {
      return this.imageExtension_
    };
    MarkerClusterer.prototype.setImageExtension = function (e) {
      this.imageExtension_ = e
    };
    MarkerClusterer.prototype.getImagePath = function () {
      return this.imagePath_
    };
    MarkerClusterer.prototype.setImagePath = function (e) {
      this.imagePath_ = e
    };
    MarkerClusterer.prototype.getImageSizes = function () {
      return this.imageSizes_
    };
    MarkerClusterer.prototype.setImageSizes = function (e) {
      this.imageSizes_ = e
    };
    MarkerClusterer.prototype.getCalculator = function () {
      return this.calculator_
    };
    MarkerClusterer.prototype.setCalculator = function (e) {
      this.calculator_ = e
    };
    MarkerClusterer.prototype.getPrintable = function () {
      return this.printable_
    };
    MarkerClusterer.prototype.setPrintable = function (e) {
      this.printable_ = e
    };
    MarkerClusterer.prototype.getBatchSizeIE = function () {
      return this.batchSizeIE_
    };
    MarkerClusterer.prototype.setBatchSizeIE = function (e) {
      this.batchSizeIE_ = e
    };
    MarkerClusterer.prototype.getClusterClass = function () {
      return this.clusterClass_
    };
    MarkerClusterer.prototype.setClusterClass = function (e) {
      this.clusterClass_ = e
    };
    MarkerClusterer.prototype.getMarkers = function () {
      return this.markers_
    };
    MarkerClusterer.prototype.getTotalMarkers = function () {
      return this.markers_.length
    };
    MarkerClusterer.prototype.getClusters = function () {
      return this.clusters_
    };
    MarkerClusterer.prototype.getTotalClusters = function () {
      return this.clusters_.length
    };
    MarkerClusterer.prototype.addMarker = function (e, t) {
      this.pushMarkerTo_(e);
      if (!t) {
        this.redraw_()
      }
    };
    MarkerClusterer.prototype.addMarkers = function (e, t) {
      var n;
      for (n = 0; n < e.length; n++) {
        this.pushMarkerTo_(e[n])
      }
      if (!t) {
        this.redraw_()
      }
    };
    MarkerClusterer.prototype.pushMarkerTo_ = function (e) {
      if (e.getDraggable()) {
        var t = this;
        google.maps.event.addListener(e, "dragend", function () {
          if (t.ready_) {
            this.isAdded = false;
            t.repaint()
          }
        })
      }
      e.isAdded = false;
      this.markers_.push(e)
    };
    MarkerClusterer.prototype.removeMarker = function (e, t) {
      var n = this.removeMarker_(e);
      if (!t && n) {
        this.repaint()
      }
      return n
    };
    MarkerClusterer.prototype.removeMarkers = function (e, t) {
      var n, r;
      var i = false;
      for (n = 0; n < e.length; n++) {
        r = this.removeMarker_(e[n]);
        i = i || r
      }
      if (!t && i) {
        this.repaint()
      }
      return i
    };
    MarkerClusterer.prototype.removeMarker_ = function (e) {
      var t;
      var n = -1;
      if (this.markers_.indexOf) {
        n = this.markers_.indexOf(e)
      } else {
        for (t = 0; t < this.markers_.length; t++) {
          if (e === this.markers_[t]) {
            n = t;
            break
          }
        }
      }
      if (n === -1) {
        return false
      }
      e.setMap(null);
      this.markers_.splice(n, 1);
      return true
    };
    MarkerClusterer.prototype.clearMarkers = function () {
      this.resetViewport_(true);
      this.markers_ = []
    };
    MarkerClusterer.prototype.repaint = function () {
      var e = this.clusters_.slice();
      this.clusters_ = [];
      this.resetViewport_(false);
      this.redraw_();
      setTimeout(function () {
        var t;
        for (t = 0; t < e.length; t++) {
          e[t].remove()
        }
      }, 0)
    };
    MarkerClusterer.prototype.getExtendedBounds = function (e) {
      var t = this.getProjection();
      var n = new google.maps.LatLng(e.getNorthEast().lat(), e.getNorthEast().lng());
      var r = new google.maps.LatLng(e.getSouthWest().lat(), e.getSouthWest().lng());
      var i = t.fromLatLngToDivPixel(n);
      i.x += this.gridSize_;
      i.y -= this.gridSize_;
      var s = t.fromLatLngToDivPixel(r);
      s.x -= this.gridSize_;
      s.y += this.gridSize_;
      var o = t.fromDivPixelToLatLng(i);
      var u = t.fromDivPixelToLatLng(s);
      e.extend(o);
      e.extend(u);
      return e
    };
    MarkerClusterer.prototype.redraw_ = function () {
      this.createClusters_(0)
    };
    MarkerClusterer.prototype.resetViewport_ = function (e) {
      var t, n;
      for (t = 0; t < this.clusters_.length; t++) {
        this.clusters_[t].remove()
      }
      this.clusters_ = [];
      for (t = 0; t < this.markers_.length; t++) {
        n = this.markers_[t];
        n.isAdded = false;
        if (e) {
          n.setMap(null)
        }
      }
    };
    MarkerClusterer.prototype.distanceBetweenPoints_ = function (e, t) {
      var n = 6371;
      var r = (t.lat() - e.lat()) * Math.PI / 180;
      var i = (t.lng() - e.lng()) * Math.PI / 180;
      var s = Math.sin(r / 2) * Math.sin(r / 2) + Math.cos(e.lat() * Math.PI / 180) * Math.cos(t.lat() * Math.PI / 180) * Math.sin(i / 2) * Math.sin(i / 2);
      var o = 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
      var u = n * o;
      return u
    };
    MarkerClusterer.prototype.isMarkerInBounds_ = function (e, t) {
      return t.contains(e.getPosition())
    };
    MarkerClusterer.prototype.addToClosestCluster_ = function (e) {
      var t, n, r, i;
      var s = 4e4;
      var o = null;
      for (t = 0; t < this.clusters_.length; t++) {
        r = this.clusters_[t];
        i = r.getCenter();
        if (i) {
          n = this.distanceBetweenPoints_(i, e.getPosition());
          if (n < s) {
            s = n;
            o = r
          }
        }
      }
      if (o && o.isMarkerInClusterBounds(e)) {
        o.addMarker(e)
      } else {
        r = new Cluster(this);
        r.addMarker(e);
        this.clusters_.push(r)
      }
    };
    MarkerClusterer.prototype.createClusters_ = function (e) {
      var t, n;
      var r;
      var i = this;
      if (!this.ready_) {
        return
      }
      if (e === 0) {
        google.maps.event.trigger(this, "clusteringbegin", this);
        if (typeof this.timerRefStatic !== "undefined") {
          clearTimeout(this.timerRefStatic);
          delete this.timerRefStatic
        }
      }
      if (this.getMap().getZoom() > 3) {
        r = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(), this.getMap().getBounds().getNorthEast())
      } else {
        r = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625))
      }
      var s = this.getExtendedBounds(r);
      var o = Math.min(e + this.batchSize_, this.markers_.length);
      for (t = e; t < o; t++) {
        n = this.markers_[t];
        if (!n.isAdded && this.isMarkerInBounds_(n, s)) {
          if (!this.ignoreHidden_ || this.ignoreHidden_ && n.getVisible()) {
            this.addToClosestCluster_(n)
          }
        }
      }
      if (o < this.markers_.length) {
        this.timerRefStatic = setTimeout(function () {
          i.createClusters_(o)
        }, 0)
      } else {
        delete this.timerRefStatic;
        google.maps.event.trigger(this, "clusteringend", this)
      }
    };
    MarkerClusterer.prototype.extend = function (e, t) {
      return function (e) {
        var t;
        for (t in e.prototype) {
          this.prototype[t] = e.prototype[t]
        }
        return this
      }.apply(e, [t])
    };
    MarkerClusterer.CALCULATOR = function (e, t) {
      var n = 0;
      var r = "";
      var i = e.length.toString();
      var s = i;
      while (s !== 0) {
        s = parseInt(s / 10, 10);
        n++
      }
      n = Math.min(n, t);
      return {text: i, index: n, title: r}
    };
    MarkerClusterer.BATCH_SIZE = 2e3;
    MarkerClusterer.BATCH_SIZE_IE = 500;
    MarkerClusterer.IMAGE_PATH = "http://google-maps-utility-library-v3.googlecode.com/svn/trunk/markerclustererplus/images/m";
    MarkerClusterer.IMAGE_EXTENSION = "png";
    MarkerClusterer.IMAGE_SIZES = [[53, 53], [56, 56], [66, 66], [78, 78], [90, 90]];

    function InfoBox(t) {
      t = t || {}, google.maps.OverlayView.apply(this, arguments), this.content_ = t.content || "", this.disableAutoPan_ = t.disableAutoPan || !1, this.maxWidth_ = t.maxWidth || 0, this.pixelOffset_ = t.pixelOffset || new google.maps.Size(0, 0), this.position_ = t.position || new google.maps.LatLng(0, 0), this.zIndex_ = t.zIndex || null, this.boxClass_ = t.boxClass || "infoBox", this.boxStyle_ = t.boxStyle || {}, this.infoBoxClearance_ = t.infoBoxClearance || new google.maps.Size(1, 1), void 0 === t.visible && (t.visible = void 0 === t.isHidden ? !0 : !t.isHidden), this.isHidden_ = !t.visible, this.alignBottom_ = t.alignBottom || !1, this.pane_ = t.pane || "floatPane", this.enableEventPropagation_ = t.enableEventPropagation || !1, this.div_ = null, this.closeListener_ = null, this.moveListener_ = null, this.contextListener_ = null, this.eventListeners_ = null, this.fixedWidthSet_ = null
    }

    InfoBox.prototype = new google.maps.OverlayView, InfoBox.prototype.createInfoBoxDiv_ = function () {
      var t, e, i, o = this, s = function (t) {
        t.cancelBubble = !0, t.stopPropagation && t.stopPropagation()
      }, n = function (t) {
        t.returnValue = !1, t.preventDefault && t.preventDefault(), o.enableEventPropagation_ || s(t)
      };
      if (!this.div_) {
        if (this.div_ = document.createElement("div"), this.setBoxStyle_(), void 0 === this.content_.nodeType ? (this.div_.innerHTML = this.content_, this.div_.appendChild(this.getCloseBoxElement_())) : (this.div_.appendChild(this.content_), this.div_.appendChild(this.getCloseBoxElement_())), this.getPanes()[this.pane_].appendChild(this.div_), this.addClickHandler_(), this.div_.style.width ? this.fixedWidthSet_ = !0 : 0 !== this.maxWidth_ && this.div_.offsetWidth > this.maxWidth_ ? (this.div_.style.width = this.maxWidth_, this.div_.style.overflow = "auto", this.fixedWidthSet_ = !0) : (i = this.getBoxWidths_(), this.div_.style.width = this.div_.offsetWidth - i.left - i.right + "px", this.fixedWidthSet_ = !1), this.panBox_(this.disableAutoPan_), !this.enableEventPropagation_) {
          for (this.eventListeners_ = [], e = ["mousedown", "mouseover", "mouseout", "mouseup", "click", "dblclick", "touchstart", "touchend", "touchmove"], t = 0; t < e.length; t++) this.eventListeners_.push(google.maps.event.addDomListener(this.div_, e[t], s));
          this.eventListeners_.push(google.maps.event.addDomListener(this.div_, "mouseover", function () {
            this.style.cursor = "default"
          }))
        }
        this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", n), google.maps.event.trigger(this, "domready")
      }
    }, InfoBox.prototype.getCloseBoxElement_ = function () {
      var t = document.createElement("span");
      return t.className = "custom-infowindow-close-element", t.innerHTML = "&times;", t
    }, InfoBox.prototype.addClickHandler_ = function () {
      var t = this.div_.querySelector(".custom-infowindow-close-element");
      this.closeListener_ = google.maps.event.addDomListener(t, "click", this.getCloseClickHandler_())
    }, InfoBox.prototype.getCloseClickHandler_ = function () {
      var t = this;
      return function (e) {
        e.cancelBubble = !0, e.stopPropagation && e.stopPropagation(), google.maps.event.trigger(t, "closeclick"), t.close()
      }
    }, InfoBox.prototype.panBox_ = function (t) {
      var e, i, o = 0, s = 0;
      if (!t && (e = this.getMap(), e instanceof google.maps.Map)) {
        e.getBounds().contains(this.position_) || e.setCenter(this.position_), i = e.getBounds();
        var n = e.getDiv(), h = n.offsetWidth, d = n.offsetHeight, l = this.pixelOffset_.width, r = this.pixelOffset_.height, a = this.div_.offsetWidth, _ = this.div_.offsetHeight, p = this.infoBoxClearance_.width, v = this.infoBoxClearance_.height, f = this.getProjection().fromLatLngToContainerPixel(this.position_);
        if (f.x < -l + p ? o = f.x + l - p : f.x + a + l + p > h && (o = f.x + a + l + p - h), this.alignBottom_ ? f.y < -r + v + _ ? s = f.y + r - v - _ : f.y + r + v > d && (s = f.y + r + v - d) : f.y < -r + v ? s = f.y + r - v : f.y + _ + r + v > d && (s = f.y + _ + r + v - d), 0 !== o || 0 !== s) {
          {
            e.getCenter()
          }
          e.panBy(o, s)
        }
      }
    }, InfoBox.prototype.setBoxStyle_ = function () {
      var t, e;
      if (this.div_) {
        this.div_.className = this.boxClass_, this.div_.style.cssText = "", e = this.boxStyle_;
        for (t in e) e.hasOwnProperty(t) && (this.div_.style[t] = e[t]);
        this.div_.style.WebkitTransform = "translateZ(0)", void 0 !== this.div_.style.opacity && "" !== this.div_.style.opacity && (this.div_.style.MsFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + 100 * this.div_.style.opacity + ')"', this.div_.style.filter = "alpha(opacity=" + 100 * this.div_.style.opacity + ")"), this.div_.style.position = "absolute", this.div_.style.visibility = "hidden", null !== this.zIndex_ && (this.div_.style.zIndex = this.zIndex_)
      }
    }, InfoBox.prototype.getBoxWidths_ = function () {
      var t, e = {top: 0, bottom: 0, left: 0, right: 0}, i = this.div_;
      return document.defaultView && document.defaultView.getComputedStyle ? (t = i.ownerDocument.defaultView.getComputedStyle(i, ""), t && (e.top = parseInt(t.borderTopWidth, 10) || 0, e.bottom = parseInt(t.borderBottomWidth, 10) || 0, e.left = parseInt(t.borderLeftWidth, 10) || 0, e.right = parseInt(t.borderRightWidth, 10) || 0)) : document.documentElement.currentStyle && i.currentStyle && (e.top = parseInt(i.currentStyle.borderTopWidth, 10) || 0, e.bottom = parseInt(i.currentStyle.borderBottomWidth, 10) || 0, e.left = parseInt(i.currentStyle.borderLeftWidth, 10) || 0, e.right = parseInt(i.currentStyle.borderRightWidth, 10) || 0), e
    }, InfoBox.prototype.onRemove = function () {
      this.div_ && (this.div_.parentNode.removeChild(this.div_), this.div_ = null)
    }, InfoBox.prototype.draw = function () {
      this.createInfoBoxDiv_();
      var t = this.getProjection().fromLatLngToDivPixel(this.position_);
      this.div_.style.left = t.x + this.pixelOffset_.width + "px", this.alignBottom_ ? this.div_.style.bottom = -(t.y + this.pixelOffset_.height) + "px" : this.div_.style.top = t.y + this.pixelOffset_.height + "px", this.div_.style.visibility = this.isHidden_ ? "hidden" : "visible"
    }, InfoBox.prototype.setOptions = function (t) {
      void 0 !== t.boxClass && (this.boxClass_ = t.boxClass, this.setBoxStyle_()), void 0 !== t.boxStyle && (this.boxStyle_ = t.boxStyle, this.setBoxStyle_()), void 0 !== t.content && this.setContent(t.content), void 0 !== t.disableAutoPan && (this.disableAutoPan_ = t.disableAutoPan), void 0 !== t.maxWidth && (this.maxWidth_ = t.maxWidth), void 0 !== t.pixelOffset && (this.pixelOffset_ = t.pixelOffset), void 0 !== t.alignBottom && (this.alignBottom_ = t.alignBottom), void 0 !== t.position && this.setPosition(t.position), void 0 !== t.zIndex && this.setZIndex(t.zIndex), void 0 !== t.infoBoxClearance && (this.infoBoxClearance_ = t.infoBoxClearance), void 0 !== t.isHidden && (this.isHidden_ = t.isHidden), void 0 !== t.visible && (this.isHidden_ = !t.visible), void 0 !== t.enableEventPropagation && (this.enableEventPropagation_ = t.enableEventPropagation), this.div_ && this.draw()
    }, InfoBox.prototype.setContent = function (t) {
      this.content_ = t, this.div_ && (this.closeListener_ && (google.maps.event.removeListener(this.closeListener_), this.closeListener_ = null), this.fixedWidthSet_ || (this.div_.style.width = ""), void 0 === t.nodeType ? (this.div_.innerHTML = t, this.div_.appendChild(this.getCloseBoxElement_())) : (this.div_.appendChild(t), this.div_.appendChild(this.getCloseBoxElement_())), this.fixedWidthSet_ || (this.div_.style.width = this.div_.offsetWidth + "px", void 0 === t.nodeType ? (this.div_.innerHTML = t, this.div_.appendChild(this.getCloseBoxElement_())) : (this.div_.appendChild(t), this.div_.appendChild(this.getCloseBoxElement_()))), this.addClickHandler_()), google.maps.event.trigger(this, "content_changed")
    }, InfoBox.prototype.setPosition = function (t) {
      this.position_ = t, this.div_ && this.draw(), google.maps.event.trigger(this, "position_changed")
    }, InfoBox.prototype.setZIndex = function (t) {
      this.zIndex_ = t, this.div_ && (this.div_.style.zIndex = t), google.maps.event.trigger(this, "zindex_changed")
    }, InfoBox.prototype.setVisible = function (t) {
      this.isHidden_ = !t, this.div_ && (this.div_.style.visibility = this.isHidden_ ? "hidden" : "visible")
    }, InfoBox.prototype.getContent = function () {
      return this.content_
    }, InfoBox.prototype.getPosition = function () {
      return this.position_
    }, InfoBox.prototype.getZIndex = function () {
      return this.zIndex_
    }, InfoBox.prototype.getVisible = function () {
      var t;
      return t = void 0 === this.getMap() || null === this.getMap() ? !1 : !this.isHidden_
    }, InfoBox.prototype.show = function () {
      this.isHidden_ = !1, this.div_ && (this.div_.style.visibility = "visible")
    }, InfoBox.prototype.hide = function () {
      this.isHidden_ = !0, this.div_ && (this.div_.style.visibility = "hidden")
    }, InfoBox.prototype.open = function (t, e) {
      var i = this;
      e && (this.position_ = e.getPosition(), this.moveListener_ = google.maps.event.addListener(e, "position_changed", function () {
        i.setPosition(this.getPosition())
      })), this.setMap(t), this.div_ && this.panBox_()
    }, InfoBox.prototype.close = function () {
      var t;
      if (this.closeListener_ && (google.maps.event.removeListener(this.closeListener_), this.closeListener_ = null), this.eventListeners_) {
        for (t = 0; t < this.eventListeners_.length; t++) google.maps.event.removeListener(this.eventListeners_[t]);
        this.eventListeners_ = null
      }
      this.moveListener_ && (google.maps.event.removeListener(this.moveListener_), this.moveListener_ = null), this.contextListener_ && (google.maps.event.removeListener(this.contextListener_), this.contextListener_ = null), this.setMap(null)
    };

    var MAP_TYPE = {
      HYBRID: google.maps.MapTypeId.HYBRID,
      TERRAIN: google.maps.MapTypeId.TERRAIN,
      ROADMAP: google.maps.MapTypeId.ROADMAP,
      SATELLITE: google.maps.MapTypeId.SATELLITE
    };

    var ZOOM_CONTROL_POSITION = {
      LEFT_TOP: google.maps.ControlPosition.LEFT_TOP,
      LEFT_CENTER: google.maps.ControlPosition.LEFT_CENTER,
      LEFT_BOTTOM: google.maps.ControlPosition.LEFT_BOTTOM,
      RIGHT_TOP: google.maps.ControlPosition.RIGHT_TOP,
      RIGHT_CENTER: google.maps.ControlPosition.RIGHT_CENTER,
      RIGHT_BOTTOM: google.maps.ControlPosition.RIGHT_BOTTOM,
    };

    var FULL_SCREEN_CONTROL_POSITION = {
      LEFT_TOP: google.maps.ControlPosition.LEFT_TOP,
      LEFT_CENTER: google.maps.ControlPosition.LEFT_CENTER,
      LEFT_BOTTOM: google.maps.ControlPosition.LEFT_BOTTOM,
      RIGHT_TOP: google.maps.ControlPosition.RIGHT_TOP,
      RIGHT_CENTER: google.maps.ControlPosition.RIGHT_CENTER,
      RIGHT_BOTTOM: google.maps.ControlPosition.RIGHT_BOTTOM,
    };

    var PLUGIN_NAME = "googlemap";
    var PLUGIN_VERSION = "v5.0.2b-custom";

    var DEFAULTS = {
      width: null,
      height: null,
      mapOptions: {
        startingPosition: {
          lat: 49.773811,
          lng: 15.771272,
          zoom: 7
        },
        mapTypeControl: true,
        mapTypeId: MAP_TYPE.ROADMAP,
        scaleControl: true,
        panControl: true,
        streetViewControl: true,
        zoomControl: true,
        zoomControlOptions: {
          position: ZOOM_CONTROL_POSITION.RIGHT_BOTTOM,
        },
        maxZoom: null,
        minZoom: null,
        scrollwheel: true,
        draggable: true,
        fullscreenControlOptions: {
          position: FULL_SCREEN_CONTROL_POSITION.RIGHT_TOP,
        },
        styles: []
      },
      markerTypes: [],
      labelFormat: {},
      showAllMarkersOnEmptyFilter: true,
      clustering: {
        enabled: false,
        mode: 'all',
        groups: {},
        iconsStyles: [],
        maxZoom: null,
        batchSize: 2000,
        batchSizeIE: 500,
        gridSize: 60
      },
      infowindowGroupping: false,
      customInfoWindow: {
        enabled: false,
        alignBottom: false,
        boxClass: 'custom-infowindow-default',
        disableAutoPan: false,
        pixelOffset: {
          x: 0,
          y: 0
        },
        borderOffset: {
          x: 5,
          y: 5
        },
        closeClickFunction: null
      },
      oneBubbleAtOnce: true,
      bubbleContentFormatter: function (mData) {
        var str = '';
        str += '<div>';
        if (mData.title) {
          str += '	<h3>' + mData.title + '</h3>';
        }
        str += '</div>';
        return str;
      },
      print: {
        selector: null,
        apiUrl: 'https://maps.googleapis.com/maps/api/staticmap?',
        customZoom: 10,
        size: '640x380'
      }
    };

    /**
     *
     * @param element
     * @param options
     * @constructor
     */
    var GoogleMap = function (element, options) {
      this.element = element;

      this.options = $.extend(true, {}, DEFAULTS, options);
      this._defaults = DEFAULTS;
      this.version = PLUGIN_VERSION;
      this._initialise();
    };

    /**
     * Init function - run this on init (builds basic map and sets basic internal variables)
     * @private
     */
    GoogleMap.prototype._initialise = function () {
      var o = this.options;

      // set given height, width ... if not given, dimensions will be taken from CSS
      if (o.width && o.height) {
        $(this.element).css({
          'width': o.width + 'px',
          'height': o.height + 'px'
        });
      }
      google.maps.visualRefresh = false;
      this._buildMap();
      // markers
      this._markersData = [];
      this._generatedMarkers = [];
      this._customMarkers = [];

      // clustering
      this._clusterers = {};
      this._clustererGroups = {};

      // shapes
      this._shapesData = [];
      this._generatedShapes = [];

      // common to shapes and markers
      this._generatedInfoWindows = [];

      // other
      this._mapListeners = [];
      this._kmlLayers = [];
      this._generatedPaths = [];

    };

    /**
     * Support function - gets and returns size of the given object {obj}
     * @param {object} obj
     * @returns {number}
     * @private
     */
    GoogleMap.prototype._getObjectLength = function (obj) {
      var cnt = 0;
      for (var x in obj) {
        if (obj.hasOwnProperty(x)) {
          cnt++;
        }
      }
      return cnt;
    };

    /**
     * Renders basic map with given options
     * @private
     */
    GoogleMap.prototype._buildMap = function () {
      var o = this.options;
      this._gmap = new google.maps.Map(this.element, {
        zoom: o.mapOptions.startingPosition.zoom,
        center: new google.maps.LatLng(o.mapOptions.startingPosition.lat, o.mapOptions.startingPosition.lng),
        mapTypeControl: o.mapOptions.mapTypeControl,
        mapTypeId: MAP_TYPE[o.mapOptions.mapTypeId] || o.mapOptions.mapTypeId,
        scaleControl: o.mapOptions.scaleControl,
        panControl: o.mapOptions.panControl,
        streetViewControl: o.mapOptions.streetViewControl,
        zoomControl: o.mapOptions.zoomControl,
        zoomControlOptions: {
          position: ZOOM_CONTROL_POSITION[o.mapOptions.zoomControlOptions.position] || o.mapOptions.zoomControlOptions.position,
        },
        maxZoom: o.mapOptions.maxZoom,
        minZoom: o.mapOptions.minZoom,
        scrollwheel: o.mapOptions.scrollwheel,
        draggable: o.mapOptions.draggable,
        styles: o.mapOptions.styles,
        fullscreenControlOptions: {
          position: FULL_SCREEN_CONTROL_POSITION[o.mapOptions.fullscreenControlOptions.position] || o.mapOptions.fullscreenControlOptions.position,
        }
      });
    };

    /**
     * loads data to this._markersData[collectionId] and executes callback, if given
     * @param {object} params      - object with:
     *
     * common
     *  collectionId {string}      - load and store data into this collection
     *  callback {function}        - execute callback after data is loaded
     *  listeners            - object with custom event listeners on marker
     *  disableInfowindow        - disable google or InfoBox infowindow
     *
     * loading data via array
     *  data {array of objects}    - data for markers [{id, lat, lng, title, ...}]
     *
     * loading data via ajax
     *  dataUrl {string}        - ajax url to get data (JSON)
     *  postData {object}        - data passed to JSON request
     *  dataSetname {string}      - level 1 key of JSON response
     */
    GoogleMap.prototype.loadMarkers = function (params) {

      var _self = this;
      var collectionId = params.collectionId || 'default';
      var filter = params.initialFilter || {};
      var fulltextFilter = params.initialFulltextFilter || {};
      var postData = params.postData || {};
      var listeners = params.listeners || null;
      var disableInfowindow = params.disableInfowindow;
      var disableInfowindowCondition = params.disableInfowindowCondition;
      this.clearMapObjectsAndInfoWindows('markers', collectionId);

      // load data via ajax
      if (params.dataUrl) {

        var dataSetName = params.dataSetName || 'markers';

        $.getJSON(params.dataUrl, postData, function (dt) {
          if (dt && dt[dataSetName].length > 0) {
            _self._markersData[collectionId] = dt[dataSetName].slice(0);
            if (typeof (params.render) == "undefined" || params.render) {
              _self._processMarkers({
                collectionId: collectionId,
                initialFilter: filter,
                initialFulltextFilter: fulltextFilter,
                listeners: listeners,
                disableInfowindow: disableInfowindow,
                disableInfowindowCondition: disableInfowindowCondition
              });
            }
          }
          _self.zoomToMarkersBounds(typeof params.zoomToMarkersBounds !== undefined ? params.zoomToMarkersBounds : null);

          if ($.isFunction(params.callback)) {
            params.callback.call(_self);
          }

        });

      }
      // load data from given array {params.data}
      else if ($.isArray(params.data)) {
        this._markersData[collectionId] = params.data.slice(0);

        if (typeof (params.render) == "undefined" || params.render) {
          this._processMarkers({
            collectionId: collectionId,
            initialFilter: filter,
            initialFulltextFilter: fulltextFilter,
            listeners: listeners,
            disableInfowindow: disableInfowindow,
            disableInfowindowCondition: disableInfowindowCondition
          });
        }
        _self.zoomToMarkersBounds(typeof params.zoomToMarkersBounds !== undefined ? params.zoomToMarkersBounds : null);

        if ($.isFunction(params.callback)) {
          params.callback.call(_self);
        }
      }

    };

    /**
     * Process given collection of markers, applies clustering, if enabled and applies initial filtering
     * @param {object} params
     *  collectionId {string} - render only markers within this collection. If null, render all collections
     *  initialFilter {object} - object of properties rules, which are applied to rendered marker - if it is visible or not
     *  initialFulltextFilter {object}
     *  listeners {object}
     * @private
     */
    GoogleMap.prototype._processMarkers = function (params) {
      var o = this.options;

      if (o.infowindowGroupping) {
        this._groupMarkersByCoordinates();
      }

      if (params.collectionId && $.isArray(this._markersData[params.collectionId])) {
        this._renderMarker(params.collectionId, this._markersData[params.collectionId], params.listeners, params.disableInfowindow, params.disableInfowindowCondition);
      } else {
        for (var collection in this._markersData) {
          if (this._markersData.hasOwnProperty(collection)) {
            this._renderMarker(collection, this._markersData[collection], params.listeners, params.disableInfowindow, params.disableInfowindowCondition);
          }
        }
      }

      if (o.clustering.enabled) {
        this._createMarkerClusters(true);
      }

      if (this._getObjectLength(params.initialFilter) > 0 || this._getObjectLength(params.initialFulltextFilter)) {
        this.filterObjects('markers', params.initialFilter, params.initialFulltextFilter);
      }

    };

    GoogleMap.prototype._groupMarkersByCoordinates = function () {
      for (var collection in this._markersData) {
        if (this._markersData.hasOwnProperty(collection)) {
          this._markersData[collection] = this._groupMarkerCollectionByCoordinates(this._markersData[collection]);
        }
      }
    };

    GoogleMap.prototype._groupMarkerCollectionByCoordinates = function (markersCollection) {

      var grouppedMarkers = {};
      var resultMarkers = [];
      var coordIndex = '';
      var actualMarker = {};

      // group by coordinates
      for (var i = 0; i < markersCollection.length; i++) {
        var marker = markersCollection[i];
        coordIndex = String(marker.lat) + 'x' + String(marker.lng);
        grouppedMarkers[coordIndex] = grouppedMarkers[coordIndex] || [];
        grouppedMarkers[coordIndex].push(marker);
      }

      // create single markers with connected additional markers with the same coords
      for (var group in grouppedMarkers) {
        if (grouppedMarkers.hasOwnProperty(group)) {
          actualMarker = grouppedMarkers[group][0]; // first marker as main - TODO - do some priority crap
          actualMarker.additionalGrouppedMarkers = [];

          for (var j = 1; j < grouppedMarkers[group].length; j++) {
            actualMarker.additionalGrouppedMarkers.push(grouppedMarkers[group][j]);
          }

          resultMarkers.push(actualMarker);
        }
      }

      return resultMarkers;
    };

    /**
     * Renders single marker, binds custom or default action to itself and stores itself into this._generatedMarkers
     * @param collectionId
     * @param markersData
     * @param listeners
     * @param disableInfowindow
     * @param disableInfowindowCondition
     * @returns {boolean}
     * @private
     */
    GoogleMap.prototype._renderMarker = function (collectionId, markersData, listeners, disableInfowindow, disableInfowindowCondition) {
      var o = this.options;
      var self = this;
      var bubbleContent = '';
      var marker, infowindow;

      for (var i = 0; i < markersData.length; i++) {

        if ($.isFunction(o.bubbleContentFormatter)) {
          bubbleContent = o.bubbleContentFormatter(markersData[i]);
        }

        const targetType = markersData[i].myType;
        let markerIcon = null;
        let markerShape = null;

        o.markerTypes.forEach(function (item) {
          if (item.name === targetType) {
            markerIcon = item.icon;
            markerShape = item.shape;
          }
        });

        var infowindowConditionallyDisabled = false;
        if ($.isFunction(disableInfowindowCondition)) {
          disableInfowindowCondition.call(this, markersData[i]);
        }

        marker = new google.maps.Marker({
          id: markersData[i].id,
          position: new google.maps.LatLng(markersData[i].lat, markersData[i].lng),
          container: this.element,
          map: this._gmap,
          title: markersData[i].title,
          cursor: (bubbleContent && bubbleContent != "") ? 'pointer' : 'default',
          type: markersData[i].type,
          myType: markersData[i].myType,
          visible: (o.showAllMarkersOnEmptyFilter && (this._getObjectLength(o.initialFilter) == 0)),
          filter: markersData[i].filter,
          fulltextData: markersData[i].fulltextData,
          collectionId: collectionId,		// internal fallback
          collection: collectionId,		// used by clustering
          customData: markersData[i].customData || {},
          label: (markersData[i].label && markersData[i].label !== "" ? $.extend(true, {}, o.labelFormat, {text: String(markersData[i].label)}) : null),
          // icon: (o.markerTypes.length > 0 && typeof(o.markerTypes[markersData[i].type]) == "object") ? o.markerTypes[markersData[i].type].icon : null,
          // shape: (o.markerTypes.length > 0 && typeof(o.markerTypes[markersData[i].type]) == "object") ? o.markerTypes[markersData[i].type].shape : null,
          icon: (o.markerTypes.length > 0 && (markerIcon != null && markerShape != null)) ? markerIcon : null,
          shape: (o.markerTypes.length > 0 && (markerIcon != null && markerShape != null)) ? markerShape : null,
          objectType: 'marker',
          markerData: markersData[i]
        });

        if (listeners) {
          for (var listener in listeners) {
            if (listeners.hasOwnProperty(listener)) {
              this.processMarkersCustomAction(marker, listener, listeners[listener], markersData[i]);
            }
          }
        }

        if (!disableInfowindow && !infowindowConditionallyDisabled && bubbleContent && bubbleContent != "") {

          if (o.customInfoWindow.enabled) {
            infowindow = this.createCustomInfowindow(marker, bubbleContent, collectionId);
            if ($.isFunction(o.customInfoWindow.closeClickFunction)) {
              google.maps.event.addListener(infowindow, 'closeclick', function () {
                o.customInfoWindow.closeClickFunction.call(self);
              });
            }
          } else {
            infowindow = this.createInfowindow(marker, bubbleContent, collectionId);
          }

          this._generatedInfoWindows.push(infowindow);
        }

        this._generatedMarkers.push(marker);

      }

      return true;
    };

    GoogleMap.prototype.createInfowindow = function (object, bubbleContent, collectionId) {
      var infowindow;
      var _self = this;
      var o = this.options;
      infowindow = new google.maps.InfoWindow({
        content: bubbleContent
      });

      infowindow.collectionId = collectionId;
      object.infowindow = infowindow;

      google.maps.event.addListener(object, 'click', function (event) {
        if (o.oneBubbleAtOnce) {
          _self.closeInfoWindows();
        }
        if (object.objectType == 'shape') {
          infowindow.setPosition(event.latLng);
          infowindow.open(_self._gmap);
        } else {
          infowindow.open(_self._gmap, object);
        }
      });

      return infowindow;

    };

    GoogleMap.prototype.createCustomInfowindow = function (object, bubbleContent, collectionId) {
      var infowindow;
      var _self = this;

      var oCIW = this.options.customInfoWindow;

      /*var customBubbleContent = document.createElement('div');
     customBubbleContent.innerHTML = bubbleContent;*/

      var options = {
        content: bubbleContent,
        disableAutoPan: oCIW.disableAutoPan,
        pixelOffset: new google.maps.Size(oCIW.pixelOffset.x, oCIW.pixelOffset.y),
        enableEventPropagation: false,
        infoBoxClearance: new google.maps.Size(oCIW.borderOffset.y, oCIW.borderOffset.x),
        isHidden: false,
        pane: 'floatPane',
        boxClass: oCIW.boxClass,
        alignBottom: oCIW.alignBottom
      };

      infowindow = new InfoBox(options);
      infowindow.collectionId = collectionId;
      object.infowindow = infowindow;

      google.maps.event.addListener(object, 'click', function (event) {
        if (_self.options.oneBubbleAtOnce) {
          _self.closeInfoWindows();
        }
        if (object.objectType == 'shape') {
          //infowindow.setPosition(event.latLng);
          //infowindow.open(_self._gmap);
        } else {
          infowindow.open(_self._gmap, object);
        }
      });

      return infowindow;
    };

    GoogleMap.prototype.processMarkersCustomAction = function (marker, listenerType, listenerAction, markersData) {
      var self = this;
      google.maps.event.addListener(marker, listenerType, function (event) {
        listenerAction.call(self, event || {}, markersData, marker);
      });
    };

    GoogleMap.prototype.zoomToMarkersBounds = function (offset) {
      if (offset == null) return false;

      var _self = this;
      // perform zoom and remove itself
      var performOffsetZoom = function () {
        _self._gmap.setZoom(_self._gmap.getZoom() + offset);
        google.maps.event.removeListener(offsetZoomListener);
      };
      var offsetZoomListener = google.maps.event.addListener(_self._gmap, 'idle', performOffsetZoom);

      var bounds = new google.maps.LatLngBounds();

      for (var i = 0; i < this._generatedMarkers.length; i++) {

        if (this._generatedMarkers[i].getVisible()) {
          bounds.extend(this._generatedMarkers[i].position);
        }
      }

      this._gmap.fitBounds(bounds);

      return true;
    };

    GoogleMap.prototype.zoomToMarkersBoundsCustom = function(bounds, infowindow) {

      var self = this;

      setTimeout(function(){
        self._gmap.fitBounds(bounds);
        self._gmap.setZoom(17);

        if (infowindow) {
          self.panToPosition({
            position: [0.5, 0.7]
          });
        }
      },500);

      return true;
    };

    /**
     * place custom marker with options in params
     * @param params
     * - id
     * - latitude
     * - longitude
     * - title
     * - draggable
     */
    GoogleMap.prototype.placeCustomMarker = function (params) {
      var o = this.options;
      var id = params.id || this._customMarkers.length++;

      if (typeof (this._customMarkers[params.id]) == "object") {
        this.removeCustomMarker({
          id: params.id
        });
      }

      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(params.latitude, params.longitude),
        container: this.element,
        map: this._gmap,
        id: params.id,
        title: params.title || '',
        cursor: params.draggable ? 'move' : 'default',
        visible: true,
        draggable: params.draggable || false,
        icon: params.iconType ? o.markerTypes[params.iconType].icon : null,
        shadow: params.iconType ? o.markerTypes[params.iconType].shadow : null,
        shape: params.iconType ? o.markerTypes[params.iconType].shape : null,
        collectionId: params.collectionId || 'default'
      });

      for (var listener in params.listeners) {
        if (params.listeners.hasOwnProperty(listener)) {
          this.bindEventToCustomMarker(marker, listener, params.listeners[listener]);
        }
      }

      if (params.zIndex) {
        marker.setZIndex(params.zIndex);
      }

      this._customMarkers[params.id] = marker;
    };
    /**
     * helper function to placeCustomMarker - prevent mutable variable
     * @param target
     * @param eventType
     * @param fnc
     */
    GoogleMap.prototype.bindEventToCustomMarker = function (target, eventType, fnc) {
      var self = this;
      google.maps.event.addListener(target, eventType, function (event) {
        if (event && event.latLng.lat() && event.latLng.lng()) {
          fnc.call(self, event.latLng.lat(), event.latLng.lng());
        } else {
          fnc.call(self);
        }

      });
    };

    /**
     * remove custom placed marker by id
     */
    GoogleMap.prototype.removeCustomMarker = function (params) {
      if (!this._customMarkers[params.id]) {
        return false;
      }
      this._customMarkers[params.id].setMap(null);
      this._customMarkers[params.id] = null;
      delete this._customMarkers[params.id];
      return true;
    };

    GoogleMap.prototype.removeCustomMarkersByCollectionId = function (collectionId) {
      for (var marker in this._customMarkers) {
        if (this._customMarkers.hasOwnProperty(marker)) {
          if (this._customMarkers[marker] != null && this._customMarkers[marker].collectionId == collectionId) {
            this._customMarkers[marker].setMap(null);
            this._customMarkers[marker] = null;
            delete this._customMarkers[marker];
          }
        }
      }
    };

    /**
     * backward compatibility method
     */
    GoogleMap.prototype.filterMarkers = function (filter, fulltextFilter, params) {
      this.filterObjects('markers', filter, fulltextFilter, params);
    };

    /**
     * goes through generated objects and enables / disables its visibility according to the filter
     * @param type
     * @param filter
     * @param fulltextFilter
     * @param params
     * @returns {boolean}
     */
    GoogleMap.prototype.filterObjects = function (type, filter, fulltextFilter, params) {
      var o = this.options;

      // decide whether to filter markers or shapes
      // to be extended with more object types coming
      var objectsToFilter = (type == 'markers') ? this._generatedMarkers : this._generatedShapes;

      if (!objectsToFilter || objectsToFilter.length == 0) {
        return false;
      }
      this.closeInfoWindows();

      var currentMarkerVisibilityByCategory, currentMarkerVisible, markerFilter, markerFulltextData;
      var fulltextType = params.fulltextType || '';
      for (var i = 0; i < objectsToFilter.length; i++) {

        if (!o.showAllMarkersOnEmptyFilter && this._getObjectLength(filter) == 0) {
          objectsToFilter[i].setVisible(false);
          continue;
        }

        if(fulltextType !== 'places') {
          if (this._getObjectLength(filter) == 0) {
            objectsToFilter[i].setVisible(false);
            continue;
          }
        }

        markerFilter = objectsToFilter[i].filter || {};
        markerFulltextData = objectsToFilter[i].fulltextData || {};
        currentMarkerVisibilityByCategory = [];
        // common data filtering
        for (var filterGroup in filter) {
          if (!filter.hasOwnProperty(filterGroup) || filter[filterGroup].length == 0) {
            continue;
          }

          currentMarkerVisibilityByCategory[filterGroup] = false;

          if ($.isArray(filter[filterGroup])) {
            if (markerFilter && !markerFilter[filterGroup]) {
              continue;
            }

            for (var i2 = 0; i2 < filter[filterGroup].length; i2++) {
              if ($.inArray(filter[filterGroup][i2], markerFilter[filterGroup]) > -1) {
                currentMarkerVisibilityByCategory[filterGroup] = true;
              }
            }
          }
        }

        if(fulltextType === 'places') {
          var address = fulltextFilter.search.toString();
          var geocoder = new google.maps.Geocoder();
          geocoder
            .geocode({ 'address': address })
            .then((result) => {
              const { results } = result;
              const location = results[0].geometry.location;
              const searchedMarkerLatLng = new google.maps.LatLng(location.lat(), location.lng());
              if (params && $.isFunction(params.onMarkerSuccess)) {
                params.onMarkerSuccess.call(this, searchedMarkerLatLng);
              }
            })
            .catch((e) => {
              console.error("Geocode was not successful for the following reason: " + e);
            });
        } else {
          // fulltext filtering
          for (var fulltextFilterGroup in fulltextFilter) {
            if (!fulltextFilter.hasOwnProperty(fulltextFilterGroup) || fulltextFilter[fulltextFilterGroup].length == 0) {
              continue;
            }

            currentMarkerVisibilityByCategory[fulltextFilterGroup] = false;

            if ($.isArray(fulltextFilter[fulltextFilterGroup])) {
              if (!markerFulltextData[fulltextFilterGroup]) {
                continue;
              }
              for (var i3 = 0; i3 < fulltextFilter[fulltextFilterGroup].length; i3++) {
                for (var i4 = 0; i4 < markerFulltextData[fulltextFilterGroup].length; i4++) {
                  if (this._removeDiacritics(markerFulltextData[fulltextFilterGroup][i4]).toLowerCase().indexOf(this._removeDiacritics(fulltextFilter[fulltextFilterGroup][i3]).toLowerCase()) > -1) {
                    currentMarkerVisibilityByCategory[fulltextFilterGroup] = true;
                  }
                }
              }
            }
          }
        }

        currentMarkerVisible = true;
        for (var resultGroup in currentMarkerVisibilityByCategory) {
          if (currentMarkerVisibilityByCategory.hasOwnProperty(resultGroup)) {
            currentMarkerVisible = currentMarkerVisible & currentMarkerVisibilityByCategory[resultGroup];
          }
        }

        if (currentMarkerVisible) {
          objectsToFilter[i].setVisible(true);

          // onMarkerSuccess
          if (params && $.isFunction(params.onMarkerSuccess)) {
            params.onMarkerSuccess.call(this, objectsToFilter[i]);
          }

          // if shape is visible, its marker needs to be visible as well
          if (type == 'shapes' && objectsToFilter[i].shapeMarker) {
            objectsToFilter[i].shapeMarker.setVisible(true);
          }
        } else {
          objectsToFilter[i].setVisible(false);

          // if shape is invisible, its marker needs to be hidden as well
          if (type == 'shapes' && objectsToFilter[i].shapeMarker) {
            objectsToFilter[i].shapeMarker.setVisible(false);
          }
        }
      }

      // repaint clusters after filtering
      if (type == 'markers' && o.clustering.enabled) {
        for (var cluster in this._clusterers) {
          if (this._clusterers.hasOwnProperty(cluster)) {
            this._clusterers[cluster].repaint();
          }
        }
      }
    };

    /**
     *
     */
    GoogleMap.prototype.clearMapObjectsAndInfoWindows = function (type, collectionId) {
      var o = this.options;
      var markersToRemove = [];
      if (!this._markersData[collectionId]) {
        return true;
      }

      var i;
      for (i = 0; i < this._generatedInfoWindows.length; i++) {
        if (this._generatedInfoWindows[i].collectionId == collectionId) {
          this._generatedInfoWindows[i].close();
          this._generatedInfoWindows.splice(i, 1);
          i--;
        }
      }

      if (type == "markers") {
        for (i = 0; i < this._generatedMarkers.length; i++) {
          if (this._generatedMarkers[i].collectionId == collectionId) {
            this._generatedMarkers[i].setMap(null);
            markersToRemove.push(this._generatedMarkers[i]);
            this._generatedMarkers.splice(i, 1);
            i--;
          }
        }

        // TODO - BETA VERSION - removing markers from multiple clusterers isn't working well
        if (o.clustering.enabled) {
          for (var cluster in this._clusterers) {
            if (this._clusterers.hasOwnProperty(cluster)) {
              this._clusterers[cluster].removeMarkers(markersToRemove);
            }
          }
        }

        this._markersData[collectionId] = [];
      }

      if (type == "shapes") {
        for (i = 0; i < this._generatedShapes.length; i++) {
          if (this._generatedShapes[i].collectionId == collectionId) {
            this._generatedShapes[i].setMap(null);
            if (this._generatedShapes[i].shapeMarker) {
              this._generatedShapes[i].shapeMarker.setMap(null);
            }
            this._generatedShapes.splice(i, 1);
            i--;
          }
        }

        this._shapesData[collectionId] = [];
      }

      return true;
    };

    /**
     * closes all generated infoWindows
     */
    GoogleMap.prototype.closeInfoWindows = function () {
      for (var i = 0; i < this._generatedInfoWindows.length; i++) {
        if (this._generatedInfoWindows[i] !== null) {
          this._generatedInfoWindows[i].close();
        }
      }
    };

    /**
     * sets center and zoom to the current map
     * @param params - object with properties:
     *  - latitude
     *  - longitude
     *  - zoom
     */
    GoogleMap.prototype.setCenterAndZoom = function (params) {
      var lat = params.lat || params.latitude;
      var lng = params.lng || params.longitude;
      this._gmap.setCenter(new google.maps.LatLng(lat, lng));
      this._gmap.setZoom(params.zoom);

      if (params.position) {
        this.panToPosition({
          position: params.position
        });
      }

    };

    GoogleMap.prototype.panToPosition = function (params) {
      if (params.position) {
        var width = Math.round($(this.element).width());
        var height = Math.round($(this.element).height());
        var actualPosition = [width / 2, height / 2];
        var newPosition = [width * params.position[0], height * params.position[1]];
        var offset = [actualPosition[0] - newPosition[0], actualPosition[1] - newPosition[1]];
        this._gmap.panBy(offset[0], offset[1]);
      }
    };

    /**
     * changes map type
     * @param type
     */
    GoogleMap.prototype.setMapType = function (type) {
      this._gmap.setMapTypeId(MAP_TYPE[type] || type);
    };

    /**
     * external map type setup
     * @param options - object of options https://developers.google.com/maps/documentation/javascript/reference#MapOptions
     */
    GoogleMap.prototype.setOptions = function (options) {
      this._gmap.setOptions(options);
    };

    /**
     * renders a path on map
     * @param pathData - array of google coordinates [new google.maps.LatLng(50.1116210001872,14.6206970146592),new google.maps.LatLng(50.1116788214025,14.6209640760919)...]
     * @param pathColor - hexacolor of the path
     * @param pathWidth - width in pixels
     * @param pathOpacity - opacity
     */
    GoogleMap.prototype.renderPath = function (pathData, pathColor, pathWidth, pathOpacity) {
      var path = new google.maps.Polyline({
        path: pathData,
        strokeColor: pathColor || '#f00',
        strokeOpacity: pathOpacity || 1.0,
        strokeWeight: pathWidth || '2'
      });

      path.setMap(this._gmap);
      this._generatedPaths.push(path);

    };


    /**
     * loads data to this._shapesData[collectionId] and executes callback, if given
     * @param params - object with:
     *  collectionId - load and store data into this collection
     *  data - pure data
     *  dataUrl - ajax url to get data (JSON)
     *  postData - data passed to JSON request
     *  callback - execute callback after data is loaded
     */
    GoogleMap.prototype.loadShapes = function (params) {
      var _self = this;
      var collectionId = params.collectionId || 'default';
      var filter = params.initialFilter || {};
      var fulltextFilter = params.initialFulltextFilter || {};
      var postData = params.postData || {};
      var listeners = params.listeners || null;
      this.clearMapObjectsAndInfoWindows('shapes', collectionId);
      if (params.dataUrl) {

        var dataSetName = params.dataSetName || 'shapes';

        $.getJSON(params.dataUrl, postData, function (dt) {
          if (dt && dt[dataSetName]) {
            _self._shapesData[collectionId] = $.extend(true, {}, dt[dataSetName]);
            if (typeof (params.render) == "undefined" || params.render) {
              _self.processShapes({
                collectionId: collectionId,
                initialFilter: filter,
                initialFulltextFilter: fulltextFilter,
                listeners: listeners
              });
            }
          }

          if ($.isFunction(params.callback)) {
            params.callback.call(_self);
          }
        });

      } else if ($.isArray(params.data)) {
        this._shapesData[collectionId] = params.data.slice(0);
        this._shapesData[collectionId] = $.extend(true, {}, params.data);

        if (typeof (params.render) == "undefined" || params.render) {
          this.processShapes({
            collectionId: collectionId,
            initialFilter: filter,
            initialFulltextFilter: fulltextFilter,
            listeners: listeners
          });
        }

        if ($.isFunction(params.callback)) {
          params.callback.call(_self);
        }
      }
    };

    /**
     * gets array of objects (shapes) and renders them to the map
     * @param params - object with:
     *  collectionId - render only shapes within this collection. If null, render all collections
     *  initialFilter - object of properties rules, which are applied to rendered shape - if it is visible or not
     */

    GoogleMap.prototype.processShapes = function (params) {
      var o = this.options;

      if (params.collectionId && $.isArray(this._shapesData[params.collectionId])) {
        this.renderShape(params.collectionId, this._shapesData[params.collectionId], params.listeners);
      } else {
        for (var collection in this._shapesData) {
          if (this._shapesData.hasOwnProperty(collection)) {
            this.renderShape(collection, this._shapesData[collection], params.listeners);
          }
        }
      }

      if (this._getObjectLength(params.initialFilter) > 0 || this._getObjectLength(params.initialFulltextFilter)) {
        this.filterObjects('shapes', params.initialFilter, params.initialFulltextFilter);
      }

    };

    /**
     * render shape on map
     * @params
     *  - data - {id, lat, lng, radius}
     *  - type
     *  - strokeColor
     *  - fillColor
     *  - strokeWidth
     *  - strokeOpacity
     *  - fillOpacity
     */

    GoogleMap.prototype.renderShape = function (collectionId, shapesData, listeners) {

      var o = this.options;
      var _self = this;
      var bubbleContent = '';
      var shape, infowindow;

      var strokeColor = shapesData.style.strokeColor || "#f00";
      var fillColor = shapesData.style.fillColor || strokeColor;
      var strokeWeight = shapesData.style.strokeWeight || 2;
      var strokeOpacity = shapesData.style.strokeOpacity || 0.8;
      var fillOpacity = shapesData.style.fillOpacity || 0.3;
      var enableShapeMarkers = shapesData.enableShapeMarkers || false;
      var shapeMarkerPointData, shapeType, shapeData, polygonCoords = [];

      for (var i = 0; i < shapesData.data.length; i++) {

        if ($.isFunction(o.bubbleContentFormatter)) {
          bubbleContent = o.bubbleContentFormatter(shapesData.data[i]);
        }

        shapeData = shapesData.data[i];
        shapeData.style = shapeData.style || {};
        shapeType = (shapeData.style.type || shapesData.style.type) || null;
        shapeMarkerPointData = {};

        switch (shapeType) {
          case 'circle':
            shape = new google.maps.Circle({
              map: this._gmap,
              strokeColor: shapeData.style.strokeColor || strokeColor,
              strokeOpacity: shapeData.style.strokeOpacity || strokeOpacity,
              strokeWeight: shapeData.style.strokeWeight || strokeWeight,
              fillColor: shapeData.style.fillColor || fillColor,
              fillOpacity: shapeData.style.fillOpacity || fillOpacity,
              center: new google.maps.LatLng(shapeData.lat, shapeData.lng),
              radius: shapeData.radius,
              filter: shapeData.filter,
              fulltextData: shapeData.fulltextData,
              container: _self.element,
              collectionId: collectionId,
              clickable: (bubbleContent && bubbleContent != ""),
              objectType: 'shape',
              visible: o.showAllMarkersOnEmptyFilter
            });

            shapeMarkerPointData.circle = new google.maps.LatLng(shapeData.lat, shapeData.lng);
            break;

          case 'polygon':
            polygonCoords = [];
            for (var point = 0; point < shapeData.points.length; point++) {
              polygonCoords.push(new google.maps.LatLng(shapeData.points[point].lat, shapeData.points[point].lng));
            }

            shape = new google.maps.Polygon({
              map: this._gmap,
              strokeColor: shapeData.style.strokeColor || strokeColor,
              strokeOpacity: shapeData.style.strokeOpacity || strokeOpacity,
              strokeWeight: shapeData.style.strokeWeight || strokeWeight,
              fillColor: shapeData.style.fillColor || fillColor,
              fillOpacity: shapeData.style.fillOpacity || fillOpacity,
              paths: polygonCoords,
              filter: shapeData.filter,
              fulltextData: shapeData.fulltextData,
              container: _self.element,
              collectionId: collectionId,
              clickable: (bubbleContent && bubbleContent != ""),
              objectType: 'shape',
              visible: o.showAllMarkersOnEmptyFilter
            });

            shapeMarkerPointData.polygon = polygonCoords.slice(0);
            break;

          default:
            break;
        }


        /*
       TODO
       if (listeners) {
       for (var listener in listeners) {
       if (listeners.hasOwnProperty(listener)) {
       this.processMarkersCustomAction(marker, listener, listeners[listener], markersData[i]);
       }
       }
       } else {
       }*/

        if (bubbleContent && bubbleContent != "") {
          infowindow = this.createInfowindow(shape, bubbleContent, collectionId);
          this._generatedInfoWindows.push(infowindow);
        }
        if (enableShapeMarkers) {
          shapeMarkerPointData.type = shapeData.type;
          shape.shapeMarker = this.renderShapeMarker(shapeType, shapeMarkerPointData, infowindow);
          this._generatedShapes.push(shape);
        }
      }

      return true;
    };

    GoogleMap.prototype.renderShapeMarker = function (type, data, infowindow) {
      var pos = (type == "circle") ? data.circle : data.polygon[0];

      var o = this.options;
      var iw = (infowindow.content && infowindow.content != "");
      var _self = this;

      var shapeMarker = new google.maps.Marker({
        position: pos,
        container: this.element,
        map: this._gmap,
        title: '',
        cursor: iw ? 'pointer' : 'default',
        visible: true,
        icon: (o.markerTypes.length > 0 && typeof (o.markerTypes[data.type]) == "object") ? o.markerTypes[data.type].icon : null,
        shape: (o.markerTypes.length > 0 && typeof (o.markerTypes[data.type]) == "object") ? o.markerTypes[data.type].shape : null,
        objectType: 'shapeMarker'
      });

      if (iw) {
        google.maps.event.addListener(shapeMarker, 'click', function (event) {
          if (o.oneBubbleAtOnce) {
            _self.closeInfoWindows();
          }
          infowindow.open(_self._gmap, shapeMarker);
        });
      }

      return shapeMarker;
    };

    /**
     * renders layer from external KMZ (zipped KML) layer
     * params
     *    id
     *    kmzFile
     *    showImmediately
     *    clickable
     *    callback
     */
    GoogleMap.prototype.renderKMZLayer = function (params) {
      var _self = this;
      var kmlLayer = new google.maps.KmlLayer(params.kmzFile, {
        preserveViewport: true,
        clickable: params.clickable || false
      });
      var showImmediately = params.showImmediately === undefined ? true : params.showImmediately;
      if (showImmediately) {
        kmlLayer.setMap(this._gmap);
      } else {
        kmlLayer.setMap(null);
      }

      this._kmlLayers.push({
        id: params.id,
        layer: kmlLayer,
        enabled: showImmediately
      });

      if (showImmediately && $.isFunction(params.callback)) {
        params.callback.call(_self);
      }
    };

    /**
     * toggles kmz layer by id
     * @param id
     */
    GoogleMap.prototype.toggleKMZLayer = function (id) {
      var kmlLayers = this._kmlLayers;
      for (var i = 0; i < kmlLayers.length; i++) {
        if (kmlLayers[i].id == id) {
          if (kmlLayers[i].enabled) {
            kmlLayers[i].layer.setMap(null);
          } else {
            kmlLayers[i].layer.setMap(this._gmap);
          }
          kmlLayers[i].enabled = !kmlLayers[i].enabled;
        }
      }
    };


    /**
     * show address by string
     * @params
     *  - address
     *  - zoom
     *  - callback
     */
    GoogleMap.prototype.findAndShowAddress = function (params) {
      var _self = this;
      var address = params.address;
      if (params.location && params.location != "") {
        address += ", " + params.location;
      }
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({'address': address}, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK && results.length > 0) {
          _self.setCenterAndZoom({
            latitude: results[0].geometry.location.lat(),
            longitude: results[0].geometry.location.lng(),
            zoom: params.zoom || 16
          });

          if ($.isFunction(params.callback)) {
            params.callback.call(_self, results[0].geometry.location.lat(), results[0].geometry.location.lng());
          }
        }
      });
    };

    /**
     * adds listener to an object
     * @param params
     * - target - target, that listens to event
     * - eventType - click, dblclick, mouseup, mousedown, mouseover, mouseout
     * - function
     */
    GoogleMap.prototype.addListener = function (params) {
      var _self = this;
      var id = params.id;
      var target = null;
      var eventType = params.eventType;

      switch (params.target) {
        case "map":
          target = this._gmap;
          break;
        default:
          break;
      }

      if (!target) {
        return false;
      }

      this._mapListeners[id] = google.maps.event.addListener(target, eventType, function (event) {
        // TODO not all events support event variable as argument
        if (event && event.latLng.lat() && event.latLng.lng()) {
          params.execute.call(_self, event.latLng.lat(), event.latLng.lng());
        } else {
          params.execute.call(_self);
        }

      });
    };

    GoogleMap.prototype.removeListener = function (params) {
      google.maps.event.removeListener(this._mapListeners[params.id]);
      this._mapListeners[params.id] = null;
      delete this._mapListeners[params.id];
    };

    GoogleMap.prototype.renderPrintVersionMap = function () {
      var url = this.options.print.apiUrl;
      url += 'center=' + this.options.mapOptions.startingPosition.lat + ',' + this.options.mapOptions.startingPosition.lng;
      url += '&zoom=' + this.options.print.customZoom;
      url += '&size=' + this.options.print.size;

      if (this._generatedMarkers.length > 0) {
        url += '&markers=';
      }
      for (var i = 0; i < this._generatedMarkers.length; i++) {
        url += this._generatedMarkers[i].position.lat() + ',' + this._generatedMarkers[i].position.lng();
        if (i < (this._generatedMarkers.length - 1)) {
          url += "|";
        }
      }
      var printImg = $('<img src="' + url + '">');
      $(this.options.print.selector).append(printImg);
    };

    /**
     *
     * @param params
     */
    GoogleMap.prototype.customMarkerAction = function (params) {
      var collectionId = params.collectionId || 'default';
      var markerId = params.markerId || null;

      if (!markerId) {
        return false;
      }

      var marker = $.grep(this._generatedMarkers, function (e) {
        return e.id == markerId && e.collectionId == collectionId;
      });

      if ($.isFunction(params.execute) && marker.length == 1) {
        params.execute.call(this, marker[0]);
      }
    };
    /**
     * creates cluster groups from this._generatedMarkers
     * @private
     */
    GoogleMap.prototype._parseGeneratedMarkersIntoClusterGroups = function () {
      var o = this.options;
      this._clustererGroups = {};

      // exit if clustering not properly set
      if (
        !o.clustering ||
        o.clustering.mode === 'all' ||
        !o.clustering.groups ||
        this._getObjectLength(o.clustering.groups) == 0
      ) {
        return false;
      }

      for (var group in o.clustering.groups) {
        if (!o.clustering.groups.hasOwnProperty(group)) continue;

        this._clustererGroups[group] = [];

        for (var i = 0; i < this._generatedMarkers.length; i++) {
          if ($.inArray(this._generatedMarkers[i][o.clustering.mode], o.clustering.groups[group].categories) > -1) {
            this._clustererGroups[group].push(this._generatedMarkers[i]);
          }
        }
      }

    };

    /**
     * Creates clusters (this._clusterers) from this._clustererGroups
     * @param {boolean} parse
     * @private
     */
    GoogleMap.prototype._createMarkerClusters = function (parse) {
      if (parse) {
        this._parseGeneratedMarkersIntoClusterGroups();
      }

      this._clusterers = {};
      var o = this.options;

      // mode all
      if (o.clustering.mode === 'all') {
        this._createSingleCluster({
          markers: this._generatedMarkers,
          id: 'all',
          iconsStyles: o.clustering.iconsStyles || []
        });
      }

      // mode type or collectionId
      for (var clustererGroup in this._clustererGroups) {
        if (!this._clustererGroups.hasOwnProperty(clustererGroup)) continue;

        this._createSingleCluster({
          markers: this._clustererGroups[clustererGroup],
          id: clustererGroup,
          iconsStyles: o.clustering.groups[clustererGroup].iconsStyles || o.clustering.iconsStyles || []
        });
      }
    };

    /**
     * Creates single MarkerClusterer instance with params.markers and saves it to this._clusterers[params.id]
     * @param {object} params
     * @private
     */
    GoogleMap.prototype._createSingleCluster = function (params) {
      var o = this.options;
      if (!params.markers || params.markers.length < 1) {
        return false;
      }

      this._clusterers[params.id] = new MarkerClusterer(this._gmap, params.markers, {
        averageCenter: true,
        ignoreHidden: true,
        styles: params.iconsStyles,
        maxZoom: o.clustering.maxZoom,
        batchSize: o.clustering.batchSize,
        batchSizeIE: o.clustering.batchSizeIE,
        gridSize: o.clustering.gridSize
      })
    };

    GoogleMap.prototype.getVersion = function () {
      console.log(this.version);
    };

    GoogleMap.prototype._removeDiacritics = function (str) {
      var sdiak = [/[áäàâãå]/g, /[čćĉ]/g, /[ď]/g, /[éěèêë]/g, /[íìîï]/g, /[ĺľ]/g, /[ňñ]/g, /[óòôö]/g, /[ŕř]/g, /[šśŝ]/g, /[ť]/g, /[úůüùûű]/g, /[ýÿŷ]/g, /[ž]/g, /[ÁÄÀÂÃÅ]/g, /[ČĆĈ]/g, /[Ď]/g, /[ÉĚÈÊË]/g, /[ÍÌÎÏ]/g, /[ĹĽ]/g, /[ŇÑ]/g, /[ÓÒÔÖ]/g, /[ŔŘ]/g, /[ŠŚŜ]/g, /[Ť]/g, /[ÚŮÜÙÛŰ]/g, /[ÝŶŸ]/g, /[Ž]/g];
      var bdiak = ["a", "c", "d", "e", "i", "l", "n", "o", "r", "s", "t", "u", "y", "z", "A", "C", "D", "E", "I", "L", "N", "O", "R", "S", "T", "U", "Y", "Z"];
      for (var i = 0; i < sdiak.length; i++) {
        str = str.replace((sdiak[i]), bdiak[i]);
      }
      return str;
    };

    /**
     * decide, which methods will be "public"
     */
    var API = {
      setCenterAndZoom: GoogleMap.prototype.setCenterAndZoom,
      setMapType: GoogleMap.prototype.setMapType,
      setOptions: GoogleMap.prototype.setOptions,
      renderPath: GoogleMap.prototype.renderPath,
      renderKMZLayer: GoogleMap.prototype.renderKMZLayer,
      toggleKMZLayer: GoogleMap.prototype.toggleKMZLayer,
      loadMarkers: GoogleMap.prototype.loadMarkers,
      loadShapes: GoogleMap.prototype.loadShapes,
      filterObjects: GoogleMap.prototype.filterObjects,
      filterMarkers: GoogleMap.prototype.filterMarkers,	// compat mode, to be removed soon, use filterObjects instead
      findAndShowAddress: GoogleMap.prototype.findAndShowAddress,
      addListener: GoogleMap.prototype.addListener,
      removeListener: GoogleMap.prototype.removeListener,
      placeCustomMarker: GoogleMap.prototype.placeCustomMarker,
      removeCustomMarker: GoogleMap.prototype.removeCustomMarker,
      renderPrintVersionMap: GoogleMap.prototype.renderPrintVersionMap,
      removeCustomMarkersByCollectionId: GoogleMap.prototype.removeCustomMarkersByCollectionId,
      customMarkerAction: GoogleMap.prototype.customMarkerAction,
      zoomToMarkersBoundsCustom: GoogleMap.prototype.zoomToMarkersBoundsCustom,
      panToPosition: GoogleMap.prototype.panToPosition,
      getVersion: GoogleMap.prototype.getVersion
    };

    /**
     * plugin go live
     * @param value - first param - decides, which action shall be executed
     *    if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
     *    if string && in API object - run method named as this value with all args[index > 0]
     * @return {*}
     */
    $.fn[PLUGIN_NAME] = function (value) {
      var args = arguments;

      return this.each(function () {
        var $this = $(this);

        // get plugin instance
        var plugin = $this.data('plugin_' + PLUGIN_NAME);

        // if there's not, create one
        if (!plugin) {
          plugin = new GoogleMap(this, value);
          $this.data('plugin_' + PLUGIN_NAME, plugin);
        }
        // if there is and first parameter is in predefined API methods, call it with rest of params
        else if (API[value]) {
          plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
        }
      });
    };


    /**
     * setDefaults with $.googlemap.setDefaults();
     */
    $[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
    $[PLUGIN_NAME].setDefaults = function (newOptions) {
      DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
    };

  }

})( jQuery, window, document );



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.gm.js